export const SITE_ACTIVE = "Active";
export const SITE_INACTIVE = "Inactive";
